import Clipboard from 'app/plugins/clipboard'
import Screens from 'app/plugins/screens'
import VueTouchEvents from 'vue3-touch-events'
import VueAccount from 'app/plugins/account'
import VueProfile from 'app/plugins/profile'
import VueSubscription from 'app/plugins/subscription'
import VueValidations from 'app/plugins/validations'
import VueShortcuts from 'app/plugins/shortcuts'
import VueMarketing from 'app/plugins/marketing'
import VuePostHog from 'app/plugins/posthog'
import VueGrafanaFaro from 'app/plugins/grafanaFaro'
import store from 'app/store'

export default (vueInstance) => {
  vueInstance.use(Clipboard)
  vueInstance.use(Screens)
  vueInstance.use(VueTouchEvents)
  vueInstance.use(VueAccount, { store })
  vueInstance.use(VueProfile, { store })
  vueInstance.use(VueSubscription, { store })
  vueInstance.use(VueValidations)
  vueInstance.use(VueShortcuts)
  vueInstance.use(VueMarketing)
  vueInstance.use(VuePostHog)
  vueInstance.use(VueGrafanaFaro)

}
